export function getImageList(page, items) {
    let { getImageListRequest, getImageListError, getImageListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_image_list',
        this.createBundle('get_image_list', { page, items }, this.GET, getImageListRequest, getImageListResult, getImageListError)
    )
}
